import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import WixStylesContext from '../../../context/wixStylesContext';
var WeeklyNowIndicator = function (_a) {
    var cellWidth = _a.cellWidth, clientRectX = _a.clientRectX, clientRectY = _a.clientRectY, bottomPosition = _a.bottomPosition;
    var _b = React.useContext(WixStylesContext), cellBorderWidth = _b.cellBorderWidth, isCurrentTimeIndicator = _b.isCurrentTimeIndicator, currentTimeLineColor = _b.currentTimeLineColor, isResponsive = _b.isResponsive;
    var indicatorSideSize = 9;
    if (window.innerWidth >= 700) {
        if (cellBorderWidth === 1) {
            indicatorSideSize = 9;
        }
        if (cellBorderWidth === 2) {
            indicatorSideSize = 12;
        }
        if (cellBorderWidth === 3) {
            indicatorSideSize = 15;
        }
    }
    else {
        if (cellBorderWidth === 1) {
            indicatorSideSize = 9;
        }
        else {
            indicatorSideSize = 11;
        }
    }
    var _c = React.useState(160), nowIndicatorTopPosition = _c[0], setNowIndicatorTopPosition = _c[1];
    var _d = React.useState('visible'), visibility = _d[0], setVisibility = _d[1];
    React.useEffect(function () {
        var getBoundingClient = function () { return __awaiter(void 0, void 0, void 0, function () {
            var nowIndicator, boundingClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!isCurrentTimeIndicator) return [3 /*break*/, 2];
                        return [4 /*yield*/, document.getElementsByClassName('fc-timegrid-now-indicator-line')];
                    case 1:
                        nowIndicator = _a.sent();
                        boundingClient = nowIndicator[0] && nowIndicator[0].getBoundingClientRect();
                        setNowIndicatorTopPosition(boundingClient.top);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        setInterval(getBoundingClient, 1000 * 60);
        getBoundingClient();
        window.addEventListener('wheel', getBoundingClient);
    }, []);
    React.useEffect(function () {
        if (isCurrentTimeIndicator) {
            bottomPosition < nowIndicatorTopPosition ||
                clientRectY > nowIndicatorTopPosition
                ? setVisibility('hidden')
                : setVisibility('visible');
        }
        else {
            setVisibility('hidden');
        }
    }, [
        nowIndicatorTopPosition,
        isCurrentTimeIndicator,
        bottomPosition,
        isResponsive,
    ]);
    return (React.createElement("div", { style: {
            //@ts-ignore
            visibility: visibility,
            position: 'absolute',
            width: "".concat(cellWidth + indicatorSideSize / 2, "px"),
            zIndex: 11,
            left: "".concat(clientRectX - indicatorSideSize / 2, "px"),
            top: "".concat(nowIndicatorTopPosition - 5, "px"),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        } },
        React.createElement("div", { className: "circle", style: {
                height: "".concat(indicatorSideSize, "px"),
                aspectRatio: '1',
                borderRadius: '50%',
                backgroundColor: currentTimeLineColor,
            } }),
        React.createElement("div", { className: "line", style: {
                height: "".concat(cellBorderWidth, "px"),
                backgroundColor: currentTimeLineColor,
                width: "100%",
            } })));
};
export default WeeklyNowIndicator;
//# sourceMappingURL=WeeklyNowIndicator.js.map